<script>
import { Bar, mixins } from 'vue-chartjs'
// import 'chartjs-plugin-labels'
import 'chartjs-plugin-datalabels'
import 'chartjs-plugin-doughnutlabel'

const { reactiveProp } = mixins

export default {
  extends: Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
    /*{
      plugins: {
        labels: [{
          render: 'value',
          fontColor: 'white',
          textShadow: false,          
          // precision: 1
        },
        {
          render: 'percentage',
          position: 'outside',
          outsidePadding: 10,
          textMargin: 10
        }
        ]
      }
    })//*/
  },
}

</script>

<style>
</style>